import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsNotification} from '@models/settings-notification.model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient) {
  }

  getSettingsNotification(): Promise<SettingsNotification> {
    const url = '/api/v1/profile/notificationPreferences';
    return this.http.get<SettingsNotification>(url).toPromise();
  }

  setSettingsNotification(model: SettingsNotification): Promise<void> {
    const url = `/api/v1/profile/notificationPreferences`;
    return this.http.put<void>(url, model).toPromise();
  }

  deleteAccount(): Promise<void> {
    const url = `/api/v1/user/delete`;
    return this.http.delete<void>(url).toPromise();
  }
}
